import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { errorToast, successToast } from "../../Toasts/Toasts";
import { getAdminSuppliersApi, setFilteredChips, clearFilteredChips, resetAdminSupplierState } from "../../../redux/features/adminSupplierSlice";

const EMPTY_CHIPS = [];

const SupplierFilter = ({
  showFilter,
  setShowFilter,
  masterData
}) => {
  
  const [filterValues, setFilterValues] = useState({
    name: "",
    country: "",
    status: "",
    dates: ""
  })
  const filteredChips = useSelector((state) => state.adminSupplier?.filteredChips || EMPTY_CHIPS);
  const dispatch = useDispatch();

  useEffect(() => {
    const dataToBeFiltered = Object.fromEntries(filteredChips);
    const transformedData = {};

    for (let key in dataToBeFiltered) {
      if (typeof dataToBeFiltered[key] === "object" && dataToBeFiltered[key]?.value) {
        transformedData[key] = dataToBeFiltered[key].value;
      } else {
        transformedData[key] = dataToBeFiltered[key];
      }
    }

    setFilterValues(prev => ({ ...prev, ...transformedData }));
  }, [filteredChips]);

  const handleClose = () => {
    setShowFilter(false);
  }

  const handleFilterChange = (field, value) => {
    setFilterValues(prev => ({ ...prev, [field]: value }));
  };

  const filterEmptyFields = (data) => {
    const filteredData = {};
    for (const key in data) {
      const value = data[key];
      if (value !== "" && value !== null && value !== undefined) {
        filteredData[key] = value;
      }
    }
    return filteredData;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const filteredData = filterEmptyFields(filterValues);

    if (Object.keys(filteredData).length === 0) {
      errorToast("No field selected for filter");
      return;
    }

    try {
      dispatch(resetAdminSupplierState());

      const chipsData = { ...filteredData };
      if (chipsData.country) {
        const selectedCountry = countryOptions?.find((c) => String(c.value) === String(chipsData.country));
        if (selectedCountry) {
          chipsData.country = { label: selectedCountry.label, value: selectedCountry.value };
        }
      }

      dispatch(setFilteredChips(Object.entries(chipsData)));
      dispatch(getAdminSuppliersApi({ filteredData, page: 1, size: 10 }));
      
      successToast("Filter applied successfully");
      setShowFilter(false);
    } catch (error) {
      errorToast("Error occurred while filtering");
    }
  };

  const handleCancel = async () => {
    setFilterValues({
      name: "",
      country: "",
      status: "",
      dates: ""
    });

    try {
      dispatch(clearFilteredChips());
      dispatch(resetAdminSupplierState());
      dispatch(getAdminSuppliersApi({ filteredData: {}, page: 1, size: 10 }));
       
      setShowFilter(false);
    } catch (error) {
      errorToast("Error occurred while clearing filters");
    }
  };

  const handleEventRequestDate = (event, picker) => {
    const dateRange = picker.startDate.format('DD-MM-YYYY') + ' - ' + picker.endDate.format('DD-MM-YYYY');
    picker.element.val(dateRange);
    
    setFilterValues(prev => ({ ...prev, dates: dateRange }));
  };

  const handleCancelRequestDate = (event, picker) => {
    picker.element.val('');
    setFilterValues(prev => ({ ...prev, dates: '' }));
  };

  const countryOptions = masterData?.countries?.map((c) => ({
    label: c.name,
    value: c.id,
    code: c.countryCode,
  }));

  const aggregatorOptions = masterData?.aggregators?.map((aggregator) => ({
    label: aggregator.name,
    value: aggregator.name,
  }));


  return (
    <Modal show={showFilter} size="md" centered enforceFocus={false}>
      <div className="modal-simple modal-edit-user">
        <div className="modal-content p-3 p-md-3">
          <Modal.Body className="p-2">
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              aria-label="Close"
            />
            <div className="text-left mb-0">
              <h3 className="mb-3">Filter</h3>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <label className="form-label">Name</label>
                <Select
                  className="mb-3"
                  options={aggregatorOptions}
                  isMulti={false}
                  isClearable={true}
                  value={aggregatorOptions?.find(opt => opt.value === filterValues?.name) || null}
                  onChange={(selectedOption) => handleFilterChange("name", selectedOption ? selectedOption.value : "")}
                  placeholder="..."
                />
              </div>

              <div className="col-lg-6">
                <label className="form-label">Country</label>
                <select
                  className="form-control form-select mb-3"
                  value={filterValues?.country || ""}
                  onChange={(e) => handleFilterChange("country", e.target.value)}
                >
                  <option value="">...</option>
                  {countryOptions?.map((country) => (
                    <option key={country.value} value={country.value}>
                      {country.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-6">
                <label className="form-label">Status</label>
                <select
                  className="form-control form-select mb-3"
                  value={filterValues?.status || ""}
                  onChange={(e) => handleFilterChange("status", e.target.value)}
                >
                  <option value="">...</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
              <div className="col-lg-6 mb-3">
                <label className="form-label">Dates</label>
                <DateRangePicker
                  initialSettings={{
                    autoUpdateInput: true,
                    locale: { cancelLabel: "Clear", format: "YYYY-MM-DD" },
                    showDropdowns: true,
                    drops: "up",
                  }}
                  onApply={handleEventRequestDate}
                  onCancel={handleCancelRequestDate}
                >
                  <input
                    type="text"
                    className="form-control flatpickr-input active"
                    placeholder="YYYY-MM-DD to YYYY-MM-DD"
                    value={filterValues?.dates || ""}
                    readOnly
                  />
                </DateRangePicker>
              </div>
            </div>

            <div className="row">
              <div className="col-12 text-center mt-2">
                <button
                  type="button"
                  className="btn btn-primary rounded-pill me-sm-3 me-1 waves-effect waves-light show-filter"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
                <button
                  type="button"
                  className="btn btn-label-secondary rounded-pill btn-reset waves-effect"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Modal.Body>
        </div>
      </div>
    </Modal>
  )
}

export default SupplierFilter